import { useMutation } from '@apollo/client';
import { createCoverageHours } from 'graphql-queries';
import { CoverageHoursDayOfWeek } from './useCoverageHours';

export type CreateCoverageHoursBlock = {
  daysOfWeek: CoverageHoursDayOfWeek[];
  startMinute: number;
  endMinute: number;
};

export type CreateCoverageHoursTeam = {
  teamId: string;
  blocks: CreateCoverageHoursBlock[];
};

export type CreateCoverageHoursParams = {
  channelId: string;
  category: string;
  issues: string[];
  timezone: string;
  teams: CreateCoverageHoursTeam[];
};

export type CreatedCoverageHoursShift = {
  id: string;
  routingId: string;
  teamId: string;
  dayOfWeek: CoverageHoursDayOfWeek;
  startMinute: number;
  endMinute: number;
  timezone?: string | null;
};

export function useCreateCoverageHours() {
  const [runCreateCoverageHours, { loading, error }] =
    useMutation(createCoverageHours);

  const createCoverageHoursMutation = async (
    params: CreateCoverageHoursParams
  ): Promise<CreatedCoverageHoursShift[]> => {
    const result = await runCreateCoverageHours({
      variables: { input: params },
    });

    return result.data?.createCoverageHours ?? [];
  };

  return { createCoverageHours: createCoverageHoursMutation, loading, error };
}
